export default "__VITE_ASSET__x4DQU7tm__"